var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.chartData.length > -1)?_c('div',[_c('span',{style:({ display: 'block', marginBottom: '8px' })},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('line-chart',{attrs:{"data":_vm.chartData,"width":"100%","height":"100%","curve":"","dataset":{
      pointRadius: 1
    },"round":4,"library":{
      scales: {
        yAxes: [
          {
            gridLines: {
              display: true,
              drawOnChartArea: false
            }
          }
        ]
      }
    }}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }